import FullWidthLayout from "@/Shared/Layout/CustomComponents/FullWidthLayout";
export function ApiAccessScreen() {
  return (
    <FullWidthLayout
      header="API Access"
      content={<div>API</div>}
      microcopy="Manage your API access and credentials"
    />
  );
}
